namespace('compass.hotel');

compass.requireLib('compass.util.format');
compass.requireLib('compass.util.parse');

compass.hotel.AvailabilityTableWidget = compass.defineWidget(function AvailabilityTableWidget(options) {

	var me = this;
	var $j = jQuery;
	var _settings = options;
	var _WUID = _settings.WUID;
	var d = jQuery.dom.getContext(this);

	var _offset = 0;
	var _maxAllowed = _settings.maxAllowed;
	var _roomTypes = _settings.hotelInfo.roomTypes;
	var _blocks = _getBlocks(_roomTypes);

	var _cf = compass.util.currencyFormatter(_settings.currencyCode, { showDecimals : 0 });
	var _maxRateDigits = 3;
	var _overMaxRate = false;

	var _shortDateFormat = (function() {
		var df = compass.util.dateFormatter('ddd');
		var shortDateFormatter = _settings.shortDateFormatter;
		return function(dateStr) {
			var formattedDate = df(compass.util.parse.ISODateParser(dateStr)) + ' ' + shortDateFormatter(compass.util.parse.ISODateParser(dateStr));
			return formattedDate;
		};
	})();

	var _render = this.render = function(widgetElem) {
		var dims = _getDimensions(_blocks);
		var availTable = d.div({ className : 'availGridWrapper offset0 columns' + dims.cols }, 
			d.div({ className : 'availTable rows' + dims.rows },
				_drawRoomTypeLabels(_blocks),
				d.div({ className : 'leftScrollButton' },
					d.middled(
						d.div({ className : 'scrollButtonLabel' },
							d.i({ className : 'fa-regular fa-circle-chevron-left' })
						)
					)
				).activate(_scrollClickHandler(-1)),
				d.div({ className : 'viewport' },
					_drawGrid(_blocks)
				),
				d.div({ className : 'rightScrollButton' },
					d.middled(
						d.div({ className : 'scrollButtonLabel' },
							d.i({ className : 'fa-regular fa-circle-chevron-right' })
						)
					)
				).activate(_scrollClickHandler(1)),
				d.div({ className : 'clear' })
			),
			d.div({ className : 'scrollGutter' },
				d.div({ className : 'scrollBar' })
			)
		);

		if(_overMaxRate) {
			availTable.find('.priceBar').addClass('largeRate');
		}

		widgetElem.append(availTable);

		var scrollBar = me.find('.scrollBar');
		scrollBar.draggable({
			axis : 'x',
			containment: 'parent',
			drag : function() {
				var wrapper = me.find('.availGridWrapper');
				wrapper.removeClass('offset' + _offset);
				_offset = Math.floor((dims.cols * (parseInt(scrollBar.css('left')) + 3)) / 477);
				wrapper.addClass('offset' + _offset);
			},
			stop : function() {
				scrollBar.attr('style', '');
			}
		});
		scrollBar.attr('style', '');
	};

	this.updateMaxAllowed = function(maxAllowed) {
		_maxAllowed = maxAllowed;
		var widgetElement = me.find('.availGridWrapper').parent();
		widgetElement.empty();
		me.render(widgetElement);
	};

	function _updateNightsAvail(stay, nights) {
		var stayNights = _.filter(nights, function(night) {
			return night.date >= stay.arrive && night.date < stay.depart;
		});

		_.each(stayNights, function(night) {
			night.avail = Math.max(0, night.avail - stay.rooms);
		});
	}

	this.updateAvailability = function(stays) {
		if (_maxAllowed > -1) {
			var rooms = _.foldl(_.pluck(stays, 'rooms'), function(acc, n) { return acc + n; }, 0);
			_maxAllowed = Math.max(0, _maxAllowed - rooms);
		}

		_.each(stays, function(stay) {
			var block = _.find(_blocks, function(block) {
				return _.find(block.roomTypes, function(roomType) {
					return roomType.blockedRoomId = stay.blocked_room_id;
				});
			});

			_updateNightsAvail(stay, block.avail);
			_.each(block.roomTypes, function(roomType) {
				_updateNightsAvail(stay, roomType.nights);
			});
		});

		var widgetElement = me.find('.availGridWrapper').parent();
		widgetElement.empty();
		me.render(widgetElement);
	};

	var _getDimensions = function(blocks) {
		var columns = _.head(blocks).avail.length;
		var rows = _.foldl(blocks, function(acc, block) {
			return acc + block.roomTypes.length;
		}, blocks.length);

		return { cols : columns, rows : rows };
	};

	var _scrollClickHandler = function(shift) {
		return function() {
			var wrapper = me.find('.availGridWrapper');
			wrapper.removeClass('offset' + _offset);
			_offset += shift;
			wrapper.addClass('offset' + _offset);
		};
	};

	var _drawRoomTypeLabels = function(blocks) {
		return d.div({ className : 'roomTypeLabels' },
			d.div({ className : 'roomTypeLabel columnHeader' }, 'Available Rooms'),
			_.map(blocks, function(block) {
				return [
					d.div({ className : 'roomTypeLabel blockHeader' }, d.middled(block.name)),
					_.map(block.roomTypes, function(roomType) {
						return d.div({ className : 'roomTypeLabel' }, d.middled(roomType.name));
					})
				];
			})
		);
	};

	var _drawGrid = function(blocks) {
		var dateHeaders = d.div({ className : 'row columnHeader' },
			_.map(_.head(blocks).avail, function(night) {
				var shortDate = _shortDateFormat(night.date);
				var date = shortDate.replace(/\s/, "<br/>");
				return d.div({ className : 'cell' }, date);
			})
		);
		return d.div({ className : 'grid' }, dateHeaders, _.map(blocks, _drawBlock));
	};

	var _drawBlock = function(block) {
		return [
			d.div({ className : 'row blockHeader' },
				_.map(block.avail, function(night) {
					return d.div({ className : 'cell' }, Math.min(_maxAllowed, night.avail));
				})
			),
			_.map(block.roomTypes, _drawRoomType)
		];
	};

	var _drawRoomType = function(roomType) {
		var nightPairs = _.zip(
			_.range(1, roomType.nights.length + 1),
			roomType.nights, 
			_.tail(roomType.nights)
		);

		var positionClass = 'start';
		return d.div({ className : 'row' },
			_.map(nightPairs, function(nightData) {
				var index = nightData[0];
				var night = nightData[1];
				var next = nightData[2];

				var priceBarClassTemplate = _.template('cell priceBar col <%= class1 %> <%= class2 %>');

				var formattedRate = _cf(night.price);
				var classes = priceBarClassTemplate({
					class1: index,
					class2: positionClass
				});

				// regex will match all digits in the string
				var matchDigits = /[0-9]/g;
				if(!_overMaxRate && formattedRate.match(matchDigits).length > _maxRateDigits) {
					_overMaxRate = true;
				}

				if(night.price === 0 || night.avail <= 0) {
					classes += ' unavail';
				} else {
					if(next === undefined || next.price != night.price || next.avail <= 0) {
						classes += ' end';
						positionClass = 'start';
					} else {
						positionClass = '';
					}
				}

				return d.div({ className : classes }, 
					d.div({ className : 'price notranslate'}, _cf(night.price))
				);
			})
		);
	};

	function _getBlocks(roomTypes) {
		var dates = _.uniq(_.flatten(_.map(roomTypes, function(roomType) {
			return _.map(_.filter(roomType.nights, function(night) {
				return night.availInfo != 'UNBLOCKED';
			}), function(night) {
				return night.date;
			});
		})).sort());

		var blockGroups = _.groupBy(roomTypes, function(rt) { return rt.blockId; });
		var blocks = _.map(blockGroups, function(roomTypes, blockId) {
			var rtProto = _.head(roomTypes);

			var nights = _.filter(rtProto.nights, function(night) {
				return _.find(dates, function(date) { return date == night.date; });
			});

			var avail = _.map(dates, function(date) {
				var night = _.find(rtProto.nights, function(n) { return date == n.date; });
				return {
					date : date,
					avail : _getNightAvail(night)
				};
			});

			var rtList = _.map(roomTypes, function(rt) {
				var nights = _.map(dates, function(date) {
					var night = _.find(rt.nights, function(n) { return date == n.date; });
					return {
						date : date,
						price : night ? (night.inclusiveRoomPrice || night.roomPrice) : 0,
						avail : _getNightAvail(night)
					};
				});

				return {
					name : rt.name,
					blockedRoomId : rt.blockedRoomId,
					nights : nights
				};
			});

			return {
				blockId : Number(blockId),
				name : rtProto.blockName,
				avail : avail,
				roomTypes : rtList
			};
		});

		return blocks;
	}

	function _getNightAvail(night) {
		return (night === undefined || night.availInfo == 'UNBLOCKED' || night.availInfo == 'CUT-OFF' || night.availInfo == 'CLOSED') ? 0 : Math.max(Math.min(_maxAllowed, Number(night.availCount)), 0);
	}

}, {
	WUID : 'defaultAvailabilityTableWidgetWUID',
	widgetName : 'AvailabilityTableWidget',
	hotelInfo : {
		roomTypes: []
	},
	currencyCode: 'USD',
	maxAllowed: 999999
});

